import { render, staticRenderFns } from "./WorkerProfile.vue?vue&type=template&id=fcc394c4&scoped=true&"
import script from "./WorkerProfile.vue?vue&type=script&lang=js&"
export * from "./WorkerProfile.vue?vue&type=script&lang=js&"
import style0 from "./WorkerProfile.vue?vue&type=style&index=0&id=fcc394c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc394c4",
  null
  
)

export default component.exports